import { fetchApplyForPublication } from '../../../repositories/coworking/v1/apply-for-publication';

import { mappers } from './mappers';
import {
  IPostApplyForPublicationStatusDependencies,
  IApplyForPublicationStatus,
  EApplyForPublicationStatus,
} from './types';

export const postApplyForPublicationStatus = async (dependencies: IPostApplyForPublicationStatusDependencies) => {
  const { httpApi, logger, parameters } = dependencies;

  try {
    return await fetchApplyForPublication<IApplyForPublicationStatus, IApplyForPublicationStatus>({
      httpApi,
      parameters,
      mappers,
    });
  } catch (error) {
    logger.error(error, {
      description: 'coworking /v1/apply-for-publication/ rejection error',
      degradation: 'Пользователь пытался отправить заявку на размещение коворкинга, но сервер не смог её обработать',
      requestParameters: { ...parameters },
    });

    return { status: EApplyForPublicationStatus.CriticalError };
  }
};
